import { cacheKeys } from "@constants/cache-keys";
import ItemsDetailView from "@features/report/components/Items/ItemsDetailView";
import type { BaseItemSchema } from "@memorang/types";
import { useQueryClient } from "@tanstack/react-query";
import { useLocalSearchParams } from "expo-router";

const DetailedListItemsReviewContainer = () => {
	const { id } = useLocalSearchParams<{
		id: string;
	}>();

	const queryClient = useQueryClient();

	const cachedData = queryClient.getQueryData<BaseItemSchema[]>([
		cacheKeys.sessionItems,
		id,
	]);

	return <ItemsDetailView sessionItems={cachedData} isDetailView />;
};

export default DetailedListItemsReviewContainer;
